import React from "react";

const ChillerTruckWhyReliable = ({ title, description, reasons }) => {
  return (
    <section className="ct-why-section">
      <div className="container">

        <div
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-once="true"
        >
          <h2 className="mb-3">{title}</h2>
          <p className="ct-why-intro">{description}</p>
        </div>

        <div
          data-aos="fade-up"
          data-aos-delay="100"
          data-aos-duration="700"
          data-aos-once="true"
        >
          {reasons.map((reason, i) => (
            <p key={i} className="ct-why-para">
              <strong>{reason.title}</strong> — {reason.description}
            </p>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ChillerTruckWhyReliable;
